import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  Label,
  FormGroup,
  Input,
  Button,
} from "reactstrap"
import useWeatherDataQuery from "store/WeatherData/useWeatherDataQuery"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "./datatables.scss"
import PaginationComponent from "components/Pagination"
import { exportWeatherDataCSV, exportWeatherDataPdf } from "store/WeatherData/weatherDataUrls"

const SoilReport = () => {
  const [deviceId, setDeviceId] = useState("DFWSA1017")
  const [page, setPage] = useState(0);
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0")
  const mm = String(today.getMonth() + 1).padStart(2, "0") //January is 0!
  const yyyy = today.getFullYear()
  const currentDateInYYYYMMDD = yyyy + "-" + mm + "-" + dd

  const [printLimit, setPrintLimit] = useState(10);
  const [startDate, setStartDate] = useState(currentDateInYYYYMMDD);
  const [endDate, setEndDate] = useState(currentDateInYYYYMMDD);

  const query = {
    limit: printLimit,
    offset: printLimit * page,
    deviceId
  }
  const {
    data: weatherData,
    isSuccess,
    refetch,
  } = useWeatherDataQuery.weatherData(query)

  useEffect(() => {
    const interval = setInterval(() => {
      refetch()
    }, 3600000)
    return () => clearInterval(interval)
  }, []);

  const [data, setData] = useState({
    columns: [],
    rows: [],
  })

  const convert24To12 = time => {
    if (!time) return "--"
    const [sHours, minutes] = time.split(":")
    const hours = +sHours % 12 || 12
    const amPm = +sHours < 12 ? "AM" : "PM"
    return `${hours}:${minutes} ${amPm}`
  }

  const roundOff = num => {
    if (!num) return 0
    return num.toFixed(2)
  }
  const convertToKph = speed => {
    if (!speed && speed === 0) return 0
    return speed * 3.6
  }


  useEffect(() => {
    if (isSuccess) {
      const columns = [
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 150,
        },
        {
          label: "Time",
          field: "time",
          sort: "asc",
          width: 270,
        },
        {
          label: "Soil pH",
          field: "soil_ph",
          sort: "asc",
          width: 100,
        },
        {
          label: "Soil Temperature (°C)",
          field: "soil_temp",
          sort: "asc",
          width: 100,
        },
        {
          label: "Soil Humidity (%)",
          field: "soil_humidity",
          sort: "asc",
          width: 200,
        },
        {
          label: "Nitrogen (mg/Kg)",
          field: "nitrogen",
          sort: "asc",
          width: 200,
        },
        {
          label: "Phosphorus (mg/Kg)",
          field: "phosphorus",
          sort: "asc",
          width: 200,
        },
        {
          label: "Potassium (mg/Kg)",
          field: "potassium",
          sort: "asc",
          width: 100,
        },

        {
          label: "Soil EC (μS/cm)",
          field: "soil_ec",
          sort: "asc",
          width: 100,
        },
        {
          label: "Leaf Wetness (%)",
          field: "leaf_wetness",
          sort: "asc",
          width: 100,
        },
      ]
      const rows = weatherData?.results?.map(item => {
        return {
          date: item.time?.split("T")[0]?.split("-").reverse().join("-") || "--",
          time: convert24To12(item.time?.split("T")[1].split(".")[0]),
          soil_ph: roundOff(item?.soil_ph),
          soil_temp: (item.soil_temp),
          soil_humidity: roundOff(item.soil_humidity),
          nitrogen: roundOff(item.nitrogen),
          phosphorus: roundOff(item.phosphorus),
          potassium: roundOff(item.potassium),
          soil_ec: roundOff(item?.soil_ec),
          leaf_wetness: roundOff(item.leaf_wetness),
          // direction: getDirection(item.direction),
        }
      })

      setData({
        columns,
        rows,
      })
    }
  }, [isSuccess, weatherData]);

  document.title = "Soil Report | KCV AWS"


  const handleExportCSV = async (e) => {
    e.preventDefault();
    try {
      let query = {
        limit: printLimit,
        offset: 0,
        deviceId,
        startDate,
        endDate
      };
      
      const response = await exportWeatherDataCSV(query);
      const blob = new Blob([response.data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'soil_data.csv';
      
      document.body.appendChild(a);
      a.click();
      
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
    } catch (error) {
      console.error(error);
    }
  };
  

  const handleExportPdf = async (e) => {
    e.preventDefault();
    try {
      let query = {
        limit: printLimit,
        offset: 0,
        deviceId,
        startDate,
        endDate
      };
      
      const response = await exportWeatherDataPdf(query);
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'soil_data.pdf';
      
      document.body.appendChild(a);
      a.click();
      
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
    } catch (error) {
      console.error(error);
    }
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid" style={{backgroundColor:'#E3FDF2'}}>
          <Breadcrumbs
            maintitle="KCV"
            title="Reports"
            breadcrumbItem="Soil Report"
          />
          <Row>
            <Col md={5}></Col>
            <Col md={7}>
              <div className="d-flex gap-2 align-items-center justify-content-end">
              {/* <FormGroup>
                <Label for="deviceId">Device Id</Label>
                <Input
                  value={deviceId}
                  onChange={e => setDeviceId(e.target.value)}
                  type="select"
                  name="deviceId"
                  id="deviceId">
                  <option value={'DFWSA1015'}>Weather 1</option>
                </Input>
                </FormGroup> */}
                <FormGroup>
                <Label for="printLimit">No of Records</Label>
                <Input
                  value={printLimit}
                  onChange={e => setPrintLimit(e.target.value)}
                  type="select"
                  name="printLimit"
                  id="printLimit">
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={150}>150</option>
                  <option value={200}>200</option>
                  <option value={250}>250</option>
                  <option value={300}>300</option>
                </Input>
              </FormGroup>
                <FormGroup>
                <Label for="startDate">Start Date</Label>
                <Input
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  type="date"
                  name="startDate"
                  id="startDate">
                </Input>
              </FormGroup>
              <FormGroup>
                <Label for="endDate">End Date</Label>
              <Input
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  type="date"
                  name="endDate"
                  id="endDate">
                </Input>
              </FormGroup>

              <Button onClick={handleExportCSV} className="mt-3 bg-primary text-white">
                Export CSV
                </Button>
                <Button onClick={handleExportPdf} className="mt-3 bg-primary text-white">
                Export Pdf
              </Button>
              </div>
              
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle className="h4">Soil Report</CardTitle>
                  <MDBDataTable
                    noBottomColumns
                    deviceIding={false}
                    paging={false}
                    responsive
                    bordered
                    data={data}
                  />
                  <div className="mt-4 d-flex justify-content-end">
                  <PaginationComponent
                    itemsCount={weatherData?.count}
                    itemsPerPage={printLimit}
                    setCurrentPage={setPage}
                    currentPage={page}
                  />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SoilReport
